import { Inbox, AlertTriangle, Archive, FolderOpen } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu'
import { Button } from '@/components/ui/Button'
import { cn } from '@/lib/utils'
import { useFilter, type FolderOption } from '@/contexts/FilterContext'

interface FolderConfig {
  label: string
  icon: React.ReactNode
}

const folderOptions: Record<FolderOption, FolderConfig> = {
  inbox: {
    label: 'Inbox',
    icon: <Inbox className="size-4" />,
  },
  spam: {
    label: 'Spam',
    icon: <AlertTriangle className="size-4" />,
  },
  archive: {
    label: 'Archive',
    icon: <Archive className="size-4" />,
  },
}

export function FolderSelector() {
  const { currentFolder, setFolder } = useFilter()
  const currentConfig = folderOptions[currentFolder] || folderOptions.inbox

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0 text-sidebar-secondary-foreground hover:bg-sidebar-secondary-accent/50"
          title={`Current folder: ${currentConfig.label}`}
        >
          <FolderOpen className="size-4" />
          <span className="sr-only">Select folder</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-36">
        {(Object.keys(folderOptions) as FolderOption[]).map((folder) => {
          const config = folderOptions[folder]
          const isActive = folder === currentFolder

          return (
            <DropdownMenuItem
              key={folder}
              onClick={() => setFolder(folder)}
              className={cn(
                "cursor-pointer gap-2",
                isActive && "bg-accent text-accent-foreground"
              )}
            >
              {config.icon}
              <span className="flex-1">{config.label}</span>
              {isActive && (
                <div className="size-1.5 rounded-full bg-primary" />
              )}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
